// extracted by mini-css-extract-plugin
export var active = "_db-7";
export var container = "_db-0";
export var evenWidth = "_db-4";
export var large = "_db-5";
export var outlet = "_db-8";
export var slide = "_db-2";
export var small = "_db-6";
export var tab = "_db-3";
export var tabs = "_db-1";